import React from 'react';
import Select from './Select';
import { useGrants } from '../../../Data/Business';

const User = (props) => {
    const {grants} = useGrants();

    if (!grants) {
        return <Select key="loading" options={[{value: '', label: 'Loading...'}]} {...props} disabled={true} />;
    }


    const options = grants.filter(u => u.userId !== null)
        .filter(g => g.status === 'Active')
        .map(u => ({value: u.userId, label: u.title}));
    if (!props.unselected) {
        options.unshift({value: '', label: props.unassigned ?? 'Unassigned'});
    }

    const disabled = !grants ? true : props.disabled;

    return <>
        <Select {...{options, disabled, ...props}} />
    </>
}

export default User;
